import { uaParser } from '@mssgme/shared';

export default uaParser(window.navigator?.userAgent);
